import { get } from "./authenticatedrequestUtil";

export const getIncomeStatementSheet = get<any>(
  ({ companyId, month, year }) =>
    `/${companyId}/reports/income-statement?month=${month}&year=${year}`
);

export const getIncomeStatementPDF = get<any>(
  ({ companyId, month, year }) =>
    `/${companyId}/reports/income-statement-pdf?month=${month}&year=${year}`
);
